import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import Typography from "@material-ui/core/Typography";
import { matchSorter } from 'match-sorter'


class DynamicAutoComplete extends React.Component {

  constructor() {
    super();
    this.state = {
      mappings: []
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.records) {
      let temp = [];

      props.records.forEach(record => {
        var searchStrings = record.SearchString.split(";").filter(x => x);

        temp.push({ ...record, SearchString: searchStrings });
      });

      return { mappings: temp, useFilterOptions: true };
    }
    else {
      return { mappings: [], useFilterOptions: false };
    }
  }

  render() {
    let field = this.props.field;

    return (
      <>
        <fieldset className="entity-fieldset">
          <Typography component="legend" color="primary">
            <legend>
              {field.IsMandatory ? "*" : ""}
              {field.FieldName}
            </legend>
          </Typography>
          <p dangerouslySetInnerHTML={{ __html: field.HelpText }}></p>
          <Autocomplete
            autoComplete={false}
            multiple={this.props.allowMultiple}
            id={field.FieldCode}
            options={this.props.fieldOptions}
            getOptionLabel={this.props.fieldOptionLabels}
            ChipProps={{ color: "secondary" }}
            filterSelectedOptions
            autoHighlight
            {... (this.state.useFilterOptions
              ? {
                filterOptions: (options, { inputValue }) => {
                  var matches = matchSorter(this.state.mappings, inputValue, { keys: ['SearchString'] });

                  if (this.props.searchResultsMapper) {
                    return matches.map(this.props.searchResultsMapper);
                  }
                  else {
                    return matches.map(x => x.Code)
                  }
                }
              }
              : {})}
            disabled={field.IsReadonly}
            defaultValue={this.props.defaultValue}
            onChange={this.props.eventHandle}
            getOptionSelected={(option, value) => {
              return option == value || (value.Code && value.Code == option); 
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                name={field.FieldCode}
                required={this.props.isRequired}
                error={this.props.fieldError ? true : false}
                variant="filled"
                margin="none"
                fullWidth
              />
            )}
          />
          <Typography variant="body2" color="error">
            {this.props.fieldError}
          </Typography>
        </fieldset>
      </>
    );
  }
}

export default DynamicAutoComplete;
